import React, { useState } from "react";
import FormSignUp from "./FormSignUp";
import FormSuccess from "./FormSuccess";
import "./Signup.css";
import Image from "../../images/svg1.svg";
import { motion } from "framer-motion";
import { animationVariants } from "../../constants/animationVariants";

const SignUp = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  function submitForm() {
    setIsSubmitted(true);
  }
  return (
    <>
      <div className="form-container" id="signin">
        <div
          className="form-content-left"
        >
          <img
            className="form-img"
            loading="lazy"
            src={Image}
            alt="spaceship"
          />
        </div>
        {!isSubmitted ? (
          <FormSignUp submitForm={submitForm} />
        ) : (
          <FormSuccess />
        )}
      </div>
    </>
  );
};

export default SignUp;
